import filters from './apiFilters'
import filterData from './apiFilterData'
import refs from './apiReferences'

export default {
  ...filters,
  ...filterData,
  ...refs,
}
